// extracted by mini-css-extract-plugin
module.exports = {"styles":"_1UAsdx61Sb-lXfIyP3Ww-c"};